import { useScrollAnimation } from '../../../hooks/useScrollAnimation';
import { useParallax } from '../../../hooks/useParallax';

export default function BenefitsSection() {
  const { ref: sectionRef, isVisible } = useScrollAnimation<HTMLElement>();
  const { ref: decorRef, style: decorStyle } = useParallax<HTMLDivElement>({ speed: 0.2, direction: 'up' });

  const benefits = [
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Экономия',
      text: 'Стоимость внешнего HRD ниже содержания штатного отдела, а эффект больше. Снижение текучки и оптимизация ФОТ дают прямую финансовую выгоду.',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Безопасность',
      text: 'Защита от штрафов и судебных споров с сотрудниками. Полная юридическая легализация кадровых процессов.',
    },
    {
      icon: 'ri-bar-chart-grouped-line',
      title: 'Результат',
      text: 'Стабильная, мотивированная команда и управляемые HR-процессы, которые работают на ваш бизнес.',
    },
  ];

  return (
    <section 
      id="cases" 
      ref={sectionRef}
      className="bg-dark py-16 sm:py-24 px-4 sm:px-8 lg:px-16 relative overflow-hidden"
    >
      {/* Parallax Decorative Elements */}
      <div ref={decorRef} style={decorStyle} className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-10 left-1/4 w-80 h-80 bg-gold/5 rounded-full blur-3xl"></div>
        <div className="absolute -bottom-20 right-1/4 w-72 h-72 bg-gold/4 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-6xl mx-auto relative z-10">
        <div 
          className={`text-center mb-10 sm:mb-16 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <div className="w-16 h-0.5 bg-gold mx-auto mb-6 sm:mb-8"></div>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4">
            <a href="#cases"><strong>Почему это выгодно?</strong></a>
          </h2>
          <p className="font-body text-sm text-white/50 max-w-xl mx-auto px-2">
            Формат работы: мы начинаем с диагностической встречи (бесплатно), определяем ключевые боли и цели, а затем предлагаем оптимальный пакет.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-8">
          {benefits.map((b, i) => (
            <div
              key={i}
              className={`bg-dark-light border border-white/10 rounded-lg p-6 sm:p-10 text-center hover:border-gold/40 hover:-translate-y-2 hover:shadow-2xl hover:shadow-gold/10 transition-all duration-500 ease-out group ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
              style={{ transitionDelay: isVisible ? `${(i + 1) * 150}ms` : '0ms' }}
            >
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6 bg-gold/10 rounded-lg group-hover:bg-gold/20 transition-colors duration-300">
                <i className={`${b.icon} text-2xl text-gold`}></i>
              </div>
              <h4 className="font-heading text-xl font-bold text-white mb-4">
                <a href="#cases">{b.title}</a>
              </h4>
              <p className="font-body text-sm text-white/60 leading-relaxed">{b.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
